import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Client, Telephone } from '../../../../../models/client';
import * as Feather from 'feather-icons';

@Component({
    selector: 'app-details-profil',
    templateUrl: './details-profil.component.html',
    styleUrls: ['./details-profil.component.scss'],
})
export class DetailsProfilComponent implements OnInit, OnDestroy {
    @Input() client: Client | null = null;
    isLoading: boolean = true;

    constructor(private toastr: ToastrService) {}

    ngOnInit(): void {
        setTimeout(() => Feather.replace(), 0);
        if (this.client) {
            this.isLoading = false;
        } else {
            setTimeout(() => {
                this.isLoading = false;
            }, 2000);
        }
    }

    ngOnDestroy(): void {}

    getWhatsAppLink(telephone: Telephone): string {
        if (!telephone?.num_tel || !telephone?.code_pays) {
            return '#';
        }
        const phoneNumber = telephone.code_pays.replace(/\D/g, '') + telephone.num_tel.replace(/\D/g, '');
        return `https://wa.me/${phoneNumber}`;
    }

    hasPhone(): boolean {
        return this.client?.telephones &&
            this.client.telephones.length > 0 &&
            !!this.client.telephones[0]?.num_tel;
    }

    hasEmail(): boolean {
        return this.client?.emails &&
            this.client.emails.length > 0 &&
            !!this.client.emails[0]?.email;
    }

}
